<script>
import Axios from '@plugin/axios'
import Layout from '@layouts/main.vue'
import Hero from '@components/ui/hero-jumbotron.vue'
import DataCenterCard from '@components/ui/cards/data-center-card.vue'
import PlainCard from '@components/ui/cards/plain-card.vue'
import Pagination from '@components/ui/basic-pagination.vue'
import ButtonSliding from '@components/ui/button-slides.vue'
import Filters from '@components/ui/filter-mobile.vue'
import queryString from 'query-string'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  page() {
    return {
      title: this.pageTitle,
      meta: [{ name: 'description', content: 'The Legal Analysis page.' }],
    }
  },
  components: {
    Layout,
    Hero,
    DataCenterCard,
    Pagination,
    ButtonSliding,
    PlainCard,
    Filters,
    vSelect,
  },
  filters: {
    excerpt: function(text, limit) {
      if (text.split(/\s+/).length > limit) {
        return (
          text
            .split(/\s+/)
            .slice(0, limit)
            .join(' ') + '...'
        )
      } else {
        return text
          .split(/\s+/)
          .slice(0, limit)
          .join(' ')
      }
    },
    plainText: function(HTML) {
      var input = HTML
      return input
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
        .replace(/<[^>]+?>/g, '')
        .replace(/\s+/g, ' ')
        .replace(/ /g, ' ')
        .replace(/>/g, ' ')
    },
  },
  data() {
    return {
      DataCenter: [],
      pageLength: null,
      // page: this.$route.query.page ? parseInt(this.$route.query.page) : 1, // this will be dynamic
      page: queryString.parse(window.location.search).page
        ? queryString.parse(window.location.search).page
        : 1,
      limit: 10, // we should ask client for this
      activeDataCenter: queryString.parse(window.location.search)['data-center']
        ? queryString.parse(window.location.search)['data-center']
        : 'laws-and-regulations',
      LPFilterSelected: [],
      LPFilterOptions: [],
      TPFilterSelected: [],
      TPFilterOptions: [],
      StatusFilterSelected: [],
      StatusFilterOptions: [],
      loadOpacity: false,
      dataTotal: 0,
      hirarki: [],
      hirarkiOptions: [],
      totalData: {
        'laws-and-regulations': {
          info: '',
          count: 0,
        },
        'court-decisions': {
          info: '',
          count: 0,
        },
        'international-conventions': {
          info: '',
          count: 0,
        },
      },

      params: [],
      generatedParams: '',
      /** language switcher global */
      lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id',

      // loading state
      isLoading: true,

      // mobile state
      isMobile: false,
      mobileFilter: {
        state: false,
        categories: false,
        filters: false,
      },
      /** for SEO, meta and hero */
      pageTitle: 'Loading...',
      pageDescription: '',
    }
  },
  watch: {
    StatusFilterSelected: function() {
      this.DataCenter = []
      // console.log(this.LPFilterSelected)
      // if (this.LPFilterSelected.length !== 0) {
      //   this.LPFilterSelected = []
      // }

      const param = {
        attribute: {
          status: this.StatusFilterSelected,
        },
      }
      this.params.page = this.page
      // if (this.LPFilterSelected.length !== 0) {
      //   param.attribute.lembaga_pengadilan = this.LPFilterSelected
      // }

      this.params = param
      if (this.StatusFilterSelected.length !== 0) {
        this.getDataCenter(this.activeDataCenter, param)
      } else {
        this.getDataCenter(this.activeDataCenter)
      }
    },
    LPFilterSelected: function() {
      this.DataCenter = []

      const param = {
        attribute: {
          lembaga_pengadilan: this.LPFilterSelected,
        },
      }
      // if (this.StatusFilterSelected.length !== 0) {
      //   param.attribute.status = this.StatusFilterSelected
      // }
      this.params.page = this.page
      this.params = param

      if (this.LPFilterSelected.length !== 0) {
        this.getDataCenter(this.activeDataCenter, param)
      } else {
        this.getDataCenter(this.activeDataCenter)
      }
    },
    hirarki: function() {
      const hirarcies = this.hirarki.join(',')
      if (hirarcies !== '') {
        this.getDataCenter(
          this.activeDataCenter,
          {
            taxonomy: {
              'hirarki-peraturan': hirarcies,
            },
          },
          'taxonomy',
          false,
          true
        )
      } else {
        this.getDataCenter(this.activeDataCenter)
      }
    },
    page: function() {
      if (this.page >= 1) {
        this.loadOpacity = true
        this.params.page = this.page
        return new Promise((resolve, reject) => {
          resolve(this.getDataCenter(this.activeDataCenter, this.params))
        })
      }
    },
  },
  mounted() {
    this.getDataCenter(this.activeDataCenter)
    this.isMobile = global.app.isMobile
    this.getTotalData()
  },
  methods: {
    /**
     * Toggle Selected Data Center Category
     */
    toggleDataCenter: function(key) {
      /** Reset filter data */
      this.page = 1
      this.DataCenter = []
      this.LPFilterOptions = []
      this.TPFilterOptions = []
      this.StatusFilterOptions = []
      this.StatusFilterSelected = []
      this.LPFilterSelected = []
      this.hirarki = []
      this.activeDataCenter = key
      this.loadOpacity = true
      return new Promise((resolve, reject) => {
        resolve(this.getDataCenter(this.activeDataCenter))
      }).catch((reject) => console.log(reject))
    },
    getTotalData: function() {
      for (const key in this.totalData) {
        var params = {
          klaster_slug: key,
          simple: true,
          lang: this.lang,
          limit: 1,
        }
        params = this.generateParams(params)
        var endpoint = `klaster-by-member-relation?${params}`
        // console.log(endpoint)
        /**
         * Do API Request
         */
        Axios.get(endpoint).then((response) => {
          if (response.data) {
            this.totalData[key].info = key
              .split('-')
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ')
            this.totalData[key].count = response.data.data_total
          }
        })
      }
    },

    /**
     * Get each data center
     * @param key
     * @param params{}
     */
    getDataCenter: function(
      key,
      param = {},
      filterType = 'attribute',
      multipleFilter = true,
      resetPage = false
    ) {
      this.isLoading = true
      if (filterType === 'attribute') {
        const filter = {
          attribute: {
            status: '',
            lembaga_pengadilan: '',
          },
        }
        if (this.StatusFilterSelected.length !== 0) {
          filter.attribute.status = this.StatusFilterSelected
        } else {
          delete filter.attribute.status
        }
        if (this.LPFilterSelected.length !== 0) {
          filter.attribute.lembaga_pengadilan = this.LPFilterSelected
        } else {
          delete filter.attribute.lembaga_pengadilan
        }
        param = { ...filter }
      }

      /** define ANY API prequisite */
      var params = {
        klaster_slug: key,
        simple: true,
        page: resetPage ? 1 : this.page,
        lang: this.lang,
        limit: this.limit,
      }
      /** params need to encoded from object to url params */
      params = this.generateParams(params, param, filterType, multipleFilter)
      /** define endpoint */
      var endpoint = `klaster-by-member-relation?${params}`
      /**
       * Do API Request
       */
      Axios.get(endpoint).then((response) => {
        const data = response.data.data
        // this.DataCenter = data
        if (
          data.length !== 0 &&
          this.activeDataCenter === 'laws-and-regulations' &&
          data[0].taksonomi.length !== 0
        ) {
          if (this.lang === 'id') {
            this.hirarkiOptions =
              data[0].taksonomi.hirarki_peraturan.data_option
          } else {
            this.hirarkiOptions =
              data[0].taksonomi.laws_and_regulation_hierarchy.data_option
          }
        }

        if (this.isMobile) {
          this.DataCenter.push(...data)
        } else {
          this.DataCenter = data
        }
        this.activeDataCenter = key
        /** Pagination */
        this.pageLength = response.data.page_total
        this.dataTotal = response.data.data_total
        // this.page = response.data.page

        /** FOR SEO and META tag */
        const keyInfo = response.data.info[this.lang + ' ']
        this.pageTitle = keyInfo[0].trim()
        this.pageDescription = keyInfo[1].trim()
        /**
         * Loop the data for filtering
         */
        data.forEach((element) => {
          /** Lembaga Pengadilan Filter */
          if (element.atribut.lembaga_pengadilan) {
            const options = {
              text: element.atribut.lembaga_pengadilan.data[0].content,
              value: element.atribut.lembaga_pengadilan.data[0].content,
            }
            this.LPFilterOptions.push(options)
          }
          /** Status Filter */
          if (
            element.atribut.status &&
            element.atribut.status !== 'undefined' &&
            element.atribut.status.data.length !== 0
          ) {
            const options = {
              text: element.atribut.status.data[0].content,
              value: element.atribut.status.data[0].content,
            }
            this.StatusFilterOptions.push(options)
          }
        })

        /** remove any loading state */
        this.loadOpacity = false
        this.isLoading = false
      })
    },
    noDuplicate: function(array) {
      var uniques = []
      var itemsFound = {}
      for (var i = 0, l = array.length; i < l; i++) {
        var stringified = JSON.stringify(array[i])
        if (itemsFound[stringified]) {
          continue
        }
        uniques.push(array[i])
        itemsFound[stringified] = true
      }
      return uniques
    },
    /**
     * Handler paginate
     */
    pageHandler: function(to) {
      this.page = to
      this.scrollToTargetAdjusted('data-center-handler')
    },

    /**
     * Handle filter state on mobile
     */
    showFilter: function(key) {
      document.getElementsByTagName('body')[0].classList.add('filterState')
      switch (key) {
        case 'categories':
          this.mobileFilter.categories = !this.mobileFilter.categories
          this.mobileFilter.filters = false
          break
        case 'filters':
          this.mobileFilter.filters = !this.mobileFilter.filters
          this.mobileFilter.categories = false
          break
        default:
          break
      }
    },

    capitalize: function(value) {
      if (!value) return ''
      const penghubung =
        'and,for,with,of,dan,serta,atau,tetapi,melainkan,padahal,sedangkan,yang,agar,supaya,biar,jika,kalau,jikalau,asalkan,bila,manakala,sejak,semenjak,sedari,sewaktu,tatkala,ketika,sementara,begitu,seraya,selagi,selama,serta,sambil,demi,setelah,sesudah,sebelumsehabis,selesai,seusai,hingga,sampai,andaikan,seandainya,umpamanya,sekiranya,biarpun,walaupun,sekalipun,sungguhpun,kendatipun,seakan-akan,seolah-olah,sebagaimana,seperti,sebagai,laksana,ibarat,daripada,alih-alih,karena,sampainya,makanya,dengan,tanpa,bahwa,as,ke'
      const str = value
        .trim()
        .replace(/ {1,}/g, ' ')
        .toLowerCase()
        .split(' ')
        .map((word) => {
          if (penghubung.split(',').includes(word)) {
            return word[0].toLowerCase() + word.slice(1)
          } else if (word[0] === '(') {
            return '(' + word.charAt(1).toUpperCase() + word.substring(2)
          }
          return word[0].toUpperCase() + word.slice(1)
        })
        .join(' ')
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
  },
}
</script>

<template>
  <Layout>
    <Hero
      height="25rem"
      :background="require('@assets/images/demo/Banner_Homepage.jpg')"
    >
      <b-container class="h-100">
        <b-row class="justify-content-center h-100">
          <div class="col-lg-12 text-center align-self-center">
            <h1
              class="text-white"
              :style="{ fontSize: '2.75rem', fontWeight: '700' }"
              >{{ pageTitle }}</h1
            >
            <p
              class="mt-3 mb-4"
              :style="{
                color: '#fff',
                fontSize: '1.2rem',
                fontWeight: '300',
              }"
              >{{ pageDescription }}</p
            >
          </div>
        </b-row>
      </b-container>
    </Hero>

    <div style="margin-top:-2rem">
      <b-row class="justify-content-center mb-5 bg-light py-5 mx-0">
        <div v-for="(info, index) in totalData" :key="index" class="col-lg-3">
          <div class="card text-center border-0 rounded-lg bg-white py-3">
            <h1 class="m-0"> {{ info.count }} </h1>
            <span>{{ $t(info.info) }}</span>
          </div>
        </div>
        <b-col cols="lg-9" class="mt-4">
          <b-alert variant="info" style="font-size:.8em" show dismissible>
            {{ $t('dif_content') }}
          </b-alert>
        </b-col>
      </b-row>
    </div>
    <b-container class="my-5">
      <b-row>
        <!-- content -->
        <b-col cols="lg-9">
          <!-- Mobile Filters -->
          <Filters v-if="isMobile">
            <div class="filterButtons">
              <b-button-group>
                <b-button @click="showFilter('categories')">
                  <b-icon icon="grid" class="mr-2"></b-icon>Categories
                </b-button>
                <b-button @click="showFilter('filters')">
                  <b-icon icon="filter" class="mr-2"></b-icon>Filter
                </b-button>
              </b-button-group>
            </div>
            <div
              class="filterContent"
              :class="mobileFilter.categories ? 'show' : ''"
            >
              <div class="d-flex" :style="{ flexDirection: 'column' }">
                <b-button
                  variant="light"
                  class="mt-3"
                  @click="toggleDataCenter('laws-and-regulations')"
                >
                  Laws and Regulation
                </b-button>
                <b-button
                  variant="light"
                  class="mt-3"
                  @click="toggleDataCenter('court-decisions')"
                >
                  Court Decisions
                </b-button>
                <b-button
                  variant="light"
                  class="mt-3"
                  @click="toggleDataCenter('international-conventions')"
                >
                  International Convetions
                </b-button>
              </div>
            </div>
            <div
              class="filterContent"
              :class="mobileFilter.filters ? 'show' : ''"
            >
              <b-form-group
                v-if="LPFilterOptions.length > 0"
                label="Lembaga Pengadilan"
              >
                <b-form-checkbox-group
                  v-model="LPFilterSelected"
                  :options="noDuplicate(LPFilterOptions)"
                  button-variant="light"
                  class="w-100"
                  items-margin-y
                  buttons
                  stacked
                ></b-form-checkbox-group>
              </b-form-group>
              <b-form-group
                v-if="TPFilterOptions.length > 0"
                label="Tahun Putusan"
              >
                <b-form-checkbox-group
                  v-model="TPFilterSelected"
                  :options="noDuplicate(TPFilterOptions)"
                  button-variant="light"
                  class="w-100"
                  items-margin-y
                  buttons
                  stacked
                ></b-form-checkbox-group>
              </b-form-group>
              <b-form-group
                v-if="StatusFilterOptions.length > 0"
                label="Status"
              >
                <b-form-checkbox-group
                  v-model="StatusFilterSelected"
                  :options="noDuplicate(StatusFilterOptions)"
                  button-variant="light"
                  class="w-100"
                  items-margin-y
                  buttons
                  stacked
                ></b-form-checkbox-group>
              </b-form-group>
            </div>
          </Filters>
          <!-- End of mobile Filter -->
          <b-row id="data-center-handler" infinity-scroll-id="data-center">
            <img
              v-show="isLoading"
              src="@assets/icons/loading.gif"
              alt="loading"
              class="loadingIcon"
            />
            <b-col
              v-for="(item, index) in DataCenter"
              :key="index"
              cols="lg-6"
              class="d-flex align-items-stretch animated fadeIn"
            >
              <!-- eslint-disable -->
              <DataCenterCard
                :title="item.title"
                heading-tag="a"
                class="w-100"
                :class="[loadOpacity ? 'isLoading' : '']"
                :url="
                  `/data-center/${activeDataCenter}/${item.slug.replaceAll(
                    '/',
                    '_'
                  )}?page=${page}&data-center=${activeDataCenter}`
                "
              >
                <!-- eslint-enable -->
                <span
                  v-if="
                    item.atribut.caption.data.length !== 0 &&
                      item.atribut.caption.data[0].content
                  "
                >
                  {{
                    capitalize(item.atribut.caption.data[0].content) | plainText
                  }}
                </span>
                <span v-else>
                  {{ capitalize(item.content) | plainText | excerpt(20) }}
                </span>
              </DataCenterCard>
            </b-col>
            <b-col
              v-if="DataCenter.length === 0 && isLoading === false"
              class="ml-4 mt-5 pl-4"
            >
              <span>
                {{ $t('No data') }}
              </span>
            </b-col>
          </b-row>
          <b-row v-if="dataTotal >= 10 && !isLoading" class="mt-4 mb-5">
            <b-col>
              <Pagination
                infinity-attr="data-center"
                :total-pages="pageLength"
                :selected-page="Number(page)"
                :is-loading="loadOpacity"
                @clicked="pageHandler"
              ></Pagination>
            </b-col>
          </b-row>
        </b-col>
        <!-- end of content -->

        <!-- sidebar -->
        <b-col v-if="!isMobile" cols="lg-3" class="mt-3">
          <h4 class="mb-4" :style="{ color: 'gray' }">
            {{ $t('Categories') }}
          </h4>
          <b-row>
            <b-col cols="12">
              <ButtonSliding
                :text="$t('Laws and Regulation')"
                background-color="#2980B9"
                type="light"
                radius="5px"
                :class="{
                  active: activeDataCenter === 'laws-and-regulations',
                  'w-100 my-2': true,
                  dataCenterSlidesButton: true,
                }"
                @click.native="toggleDataCenter('laws-and-regulations')"
              >
              </ButtonSliding>
              <ButtonSliding
                :text="$t('Court Decisions')"
                background-color="#1b3665"
                type="light"
                radius="5px"
                :class="{
                  active: activeDataCenter === 'court-decisions',
                  'w-100 my-2': true,
                  dataCenterSlidesButton: true,
                }"
                @click.native="toggleDataCenter('court-decisions')"
              >
              </ButtonSliding>
              <ButtonSliding
                :text="$t('International Conventions')"
                background-color="#f6921e"
                type="light"
                radius="5px"
                :class="{
                  active: activeDataCenter === 'international-conventions',
                  'w-100 my-2': true,
                  dataCenterSlidesButton: true,
                }"
                @click.native="toggleDataCenter('international-conventions')"
              >
              </ButtonSliding>
            </b-col>
          </b-row>
          <b-row
            v-if="activeDataCenter === 'laws-and-regulations'"
            class="my-3"
          >
            <b-col cols="12">
              <h5>{{ $t('Hierarchy of Rules') }}</h5>
              <vSelect
                v-model="hirarki"
                multiple
                label="title"
                :placeholder="`--- ` + $t('Choose') + ` ---`"
                :options="hirarkiOptions"
                :reduce="(hirarki) => `${hirarki.ktaksonomi_record_id}`"
              >
                <template v-slot:no-options>
                  {{ $t('No data') }}
                </template>
              </vSelect>
            </b-col>
          </b-row>
          <!-- filters -->
          <b-row>
            <b-col cols="12">
              <PlainCard
                v-if="LPFilterOptions.length > 0"
                v-show="activeDataCenter !== 'laws-and-regulations'"
                title="Filter Lembaga Pengadilan"
                heading-tag="h6"
                class="mt-4"
              >
                <b-form-group>
                  <b-form-checkbox-group
                    v-model="LPFilterSelected"
                    :options="noDuplicate(LPFilterOptions)"
                    items-margin-y
                    plain
                    stacked
                  ></b-form-checkbox-group>
                </b-form-group>
              </PlainCard>
              <PlainCard
                v-if="TPFilterOptions.length > 0"
                title="Filter Tahun Putusan"
                heading-tag="h6"
                class="mt-4"
              >
                <b-form-group>
                  <b-form-checkbox-group
                    v-model="TPFilterSelected"
                    :options="noDuplicate(TPFilterOptions)"
                    items-margin-y
                    plain
                    stacked
                  ></b-form-checkbox-group>
                </b-form-group>
              </PlainCard>
              <PlainCard
                v-if="StatusFilterOptions.length > 0"
                title="Filter Status"
                heading-tag="h6"
                class="mt-4"
              >
                <b-form-group>
                  <b-form-checkbox-group
                    v-model="StatusFilterSelected"
                    :options="noDuplicate(StatusFilterOptions)"
                    items-margin-y
                    plain
                    stacked
                  ></b-form-checkbox-group>
                </b-form-group>
              </PlainCard>
            </b-col>
          </b-row>
        </b-col>
        <!-- end of sidebar -->
      </b-row>
    </b-container>
  </Layout>
</template>

<style lang="scss">
.dataCenterSlidesButton {
  padding: 1rem 2rem !important;
  background-color: #f7f7f7;
}
[items-margin-y] {
  padding: 0 0.5rem;
  [class='form-check'] {
    margin: 1rem 0;
  }
}
</style>
